import L from "leaflet";
import "leaflet-control-geocoder";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import { useEffect, useRef, useState } from "react";

const useMap = () => {
  const mapRef = useRef<HTMLDivElement | null>(null);
  const [map, setMap] = useState<L.Map | null>(null);
  const baseLayersRef = useRef<Record<string, L.TileLayer>>({});

  useEffect(() => {
    if (!mapRef.current || map) return;

    const openStreetMap = L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }
    );

    const stadiaMaps = L.tileLayer(
      `https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.{ext}?api_key=${
        import.meta.env.VITE_API_KEY_STADIAMAP
      }`,
      {
        attribution:
          '&copy; CNES, Distribution Airbus DS, © Airbus DS, © PlanetObserver (Contains Copernicus Data) | &copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        ext: "jpg",
      }
    );

    baseLayersRef.current = {
      "Vue Satellite": stadiaMaps,
      "Vue Standard": openStreetMap,
    };

    const newMap = L.map(mapRef.current, {
      renderer: L.canvas(),
      center: [2.842170943040401e-14, -5.625000000066052],
      zoom: 1,
      // center: [48.8584, 2.2945], // Tour Eiffel
      // zoom: 16, // Zoom rapproché sur le monument
      layers: [stadiaMaps], // default layer
    });

    setMap(newMap);
  }, [mapRef, map]);

  return { map, mapRef, baseLayers: baseLayersRef.current };
};
export default useMap;
